import Vue from 'vue'
import VueRouter from 'vue-router'

import {
  authedMiddleware,
  redirectToDefaultRoute
} from '@/service/auth/authService'

/*================================ Layouts ==============================*/
import DashboardLayout from '@/layouts/DashboardLayout'
/*================================ Pages ==============================*/

/*======= TOOLS =======*/
import PdfReportLibrary from '@/views/tools/pdf_reports/PdfReportLibrary'
import PdfReportTableModuleEditor from '@/views/tools/pdf_reports/Modules/TableEditor/TableEditor'
import PdfReportTrackerTableModuleEditor from '@/views/tools/pdf_reports/Modules/TrackerTableEditor/TrackerTableEditor'
import PdfReportSectionDividerEditor from '@/views/tools/pdf_reports/Modules/SectionDividerEditor/SectionDividerEditor'
import PdfReportTitleModuleEditor from '@/views/tools/pdf_reports/Modules/TitleModuleEditor/TitleModuleEditor'
import PdfReportEditor from '@/views/tools/pdf_reports/PdfReportEditor'
import PdfReportSettings from '@/views/tools/pdf_reports/PdfReportSettings'
import ChequeSearch from '@/views/tools/ChequeSearch'
import Expression from '@/views/tools/expressions/Expressions'
import ReportsConfig from '@/views/tools/reports_config/ReportsConfig'
import ConfigVisualizer from '@/components/reports/debug/ConfigVisualizer'
import ExpressionPrototyper from '@/views/tools/expressions/ExpressionPrototyper'
import CompanySettings from '@/views/tools/CompanySettings'
import LocationSettings from '@/views/tools/LocationSettings'
/*==== END OF TOOLS ====*/

/*======= INTERNAL =======*/
import IntegrationAccounts from '@/views/integrations/accounts/index'
import IntegrationEmbedder from '@/views/integrations/accounts/IntegrationEmbedder'
import MeasureGroups from '@/views/internal/configuration/content/measure_groups/index'
import DimensionGroups from '@/views/internal/configuration/content/dimension_groups/index'
/*==== END OF INTERNAL ====*/

/*======= DATA =======*/
import Integrations from '@/views/data/integrations/index'
import IntegrationsRedirect from '@/views/data/integrations/IntegrationsRedirect'
import ForecastUploader from '@/views/data/ForecastUploader'
import AttributesHome from '@/views/data/attributes/AttributesHome'
import ManageAttributes from '@/views/data/attributes/ManageAttributes'
import ManageConsolidatedValues from '@/views/data/attributes/ManageConsolidatedValues'
import EditAttribute from '@/views/data/attributes/EditAttribute'
/*==== END OF DATA ====*/

/*======= REPORTS =======*/
import DashboardNavigator from '@/views/reports/DashboardNavigator'
import Dashboard from '@/views/reports/dashboard/index'
/*==== END OF REPORTS ====*/

/*======= MISC =======*/
import NotFound from '@/views/misc/404Page'
/*==== END OF MISC ====*/

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    beforeEnter: redirectToDefaultRoute,
  },
  {
    path: '/company/:company_id',
    component: DashboardLayout,
    beforeEnter: authedMiddleware,
    children: [
      {
        path: '/',
        beforeEnter: redirectToDefaultRoute,
      },

      /*======= REPORTS =======*/
      {
        name: 'report',
        path: 'reports/:dashboard_id',
        component: DashboardNavigator,
        meta: {
          displayName: 'Report',
          param: 'dashboard_id',
        },
      },
      {
        name: 'dashboard',
        path: 'dashboard/:id',
        component: Dashboard,
        meta: {
          param: 'id',
          displayName: 'Dashboard',
        },
      },

      /*======= DATA =======*/
      {
        name: 'attributes',
        path: 'data/entity_attributes',
        component: AttributesHome,
        meta: {
          displayName: 'Attributes',
        },
      },
      {
        name: 'manage_attributes',
        path: 'data/attributes/manage/:entity_type',
        component: ManageAttributes,
        meta: {
          displayName: 'Manage Attributes',
        },
      },
      {
        name: 'manage_consolidated_values',
        path: 'data/attributes/consolidated_values/:entity_type',
        component: ManageConsolidatedValues,
        meta: {
          displayName: 'Manage Attributes',
        },
      },
      {
        name: 'edit_attribute',
        path: 'data/attributes/manage/:entity_type/:attribute_id',
        component: EditAttribute,
        meta: {
          displayName: 'Manage Attributes',
        },
      },

      {
        name: 'forecast_uploader',
        path: 'data/forecast_uploader',
        component: ForecastUploader,
        meta: {
          displayName: 'Upload Forecasts',
        },
      },
      {
        name: 'integrations_page',
        path: 'data/integrations',
        component: Integrations,
        meta: {
          displayName: 'Integrations',
        },
      },
      {
        name: 'integration_embedder',
        path: 'data/integrationsv2',
        component: IntegrationEmbedder,
        meta: {
          displayName: 'Integrations v2',
        },
      },

      /*======= ADMIN =======*/
      {
        name: 'company_settings',
        path: 'admin/company_settings',
        component: CompanySettings,
        meta: {
          displayName: 'Company Settings',
        },
      },
      {
        name: 'location_settings',
        path: 'admin/location_settings/:location_id',
        component: LocationSettings,
        meta: {
          param: 'location_id',
          displayName: 'Location Settings',
        },
      },

      /*======= INTEGRATIONS =======*/
      {
        name: 'integration_accounts',
        path: 'integrations/accounts',
        component: IntegrationAccounts,
        meta: {
          displayName: 'Integration Accounts',
        },
      },

      /*======= INTERNAL =======*/
      {
        name: 'internal_measure_groups',
        path: 'internal_config/content/measure_groups',
        component: MeasureGroups,
      },
      {
        name: 'internal_dimension_groups',
        path: 'internal_config/content/dimension_groups',
        component: DimensionGroups,
      },

      /*======= TOOLS =======*/
      {
        path: 'tools/checks',
        name: 'checks',
        component: ChequeSearch,
        meta: {
          displayName: 'Checks',
        },
        children: [
          {
            name: 'check',
            path: ':cheque_id',
            component: ChequeSearch,
            meta: {
              param: 'cheque_id',
            },
          },
        ],
      },
      {
        path: 'tools/expression_prototyper',
        component: ExpressionPrototyper,
        name: 'expression_prototyper',
        meta: {
          displayName: 'Expression Prototyper',
        },
      },
      {
        name: 'expressions',
        path: 'tools/expressions',
        component: Expression,
        meta: {
          displayName: 'Expressions',
        },
      },
      {
        name: 'reports_config',
        path: 'tools/reports/config',
        component: ReportsConfig,
        meta: {
          displayName: 'Definitions',
        },
      },
      {
        name: 'reports_config_visulizer',
        path: 'tools/reports/config/visualize',
        component: ConfigVisualizer,
        meta: {
          displayName: 'Visualize Reports Configuration',
        },
      },
      {
        name: 'email_report_builder',
        path: 'tools/email_report_builder',
        component: PdfReportLibrary,
        meta: {
          displayName: 'Email Report Builder',
        },
      },
      {
        name: 'pdf_report_editor',
        path: 'tools/email_report_builder/:report_id',
        component: PdfReportEditor,
        meta: {
          displayName: 'Report',
          param: 'report_id',
        },
      },

      {
        name: 'pdf_report_table_editor',
        displayName: 'Pivot Table',
        path: 'tools/email_report_builder/:report_id/table_module/:module_id',
        component: PdfReportTableModuleEditor,
        meta: {
          displayName: 'Pivot Table',
          param: 'module_id',
        },
      },
      {
        name: 'pdf_report_title_module_editor',
        displayName: 'Title',
        path: 'tools/email_report_builder/:report_id/title_module/:module_id',
        component: PdfReportTitleModuleEditor,
        meta: {
          displayName: 'Title',
          param: 'module_id',
        },
      },
      {
        name: 'pdf_report_section_divider_editor',
        path: 'tools/email_report_builder/:report_id/section_divider_module/:module_id',
        component: PdfReportSectionDividerEditor,
        meta: {
          displayName: 'Divider',
          param: 'module_id',
        },
      },

      {
        name: 'pdf_report_tracker_table_editor',
        path: 'tools/email_report_builder/:report_id/tracker_table_module/:module_id',
        component: PdfReportTrackerTableModuleEditor,
        meta: {
          displayName: 'Tracker Table',
          param: 'module_id',
        },
      },

      {
        name: 'pdf_report_settings',
        path: 'tools/email_report_builder/:report_id/settings',
        component: PdfReportSettings,
        meta: {
          displayName: 'Report Settings',
          param: 'report_id',
        },
      },
    ],
  },

  {
    name: 'integrations_redirect_page',
    path: '/integrations/oauth_redirect',
    component: IntegrationsRedirect,
  },

  {
    path: '/404',
    component: NotFound,
  },
  {
    path: '*',
    redirect: '/404',
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
